export const POSTER_CARD_BG = '#8E8E93';
export const POSTER_CARD_RADIUS = '20px';
export const POSTER_INFO_BAR_HEIGHT = '29%';
export const POSTER_INFO_BAR_BG_DARK = 'rgba(70, 70, 78, 0.45)';
export const POSTER_INFO_BAR_BG_LIGHT = 'rgba(255, 255, 255, 0.55)';
export const POSTER_INFO_BAR_BLUR = 'blur(20px) saturate(180%)';
export const POSTER_FACE_ASPECT_RATIO = '364 / 455';
const POSTER_FACE_TOP_PERCENT = 18;
const POSTER_FACE_SIDE_PERCENT = 7;
export const POSTER_FACE_TOP_RATIO = POSTER_FACE_TOP_PERCENT / 100;
export const POSTER_FACE_SIDE_RATIO = POSTER_FACE_SIDE_PERCENT / 100;
export const POSTER_FACE_WIDTH_RATIO =
  (100 - 2 * POSTER_FACE_SIDE_PERCENT) / 100;
export const POSTER_PHONE_FRAME_ASPECT = 20 / 9;
export const POSTER_FACE_INSET = `${POSTER_FACE_TOP_PERCENT}% ${POSTER_FACE_SIDE_PERCENT}% auto ${POSTER_FACE_SIDE_PERCENT}%`;
